import React from 'react';

import ImageBackground from '@components/_shared/imageBackground';
import { colorsByTheme } from '@utils/constants/colors';
import { NYCLandingType } from '@utils/types/landings';
import ContactForm from '@components/landing/_shared/contactForm';

import styles from './styles.module.scss';

const HeroSection = (props: NYCLandingType['heroSection']) => {
  const { title, subtitle, backgroundImage, formTitle, cta, items } = props;

  const onScrollDownClick = () => {
    if (window && window.scrollY < window.innerHeight - 200) {
      window.scrollTo({
        top: window.innerHeight - 200,
        behavior: 'smooth',
      });
    }
  };

  return (
    <ImageBackground
      containerStyle={styles.hero}
      backgroundImageStyle={`
        ${colorsByTheme['dark'].imageBackgroundWithGradientBottom},
        url('${backgroundImage}')
      `}
    >
      <div className={styles.hero__wrapper}>
        <div className={styles.hero__textBlock}>
          <h1 className={styles.hero__title}>{title}</h1>
          <div className={styles.hero__subtitle}>{subtitle}</div>
        </div>

        <ContactForm
          formTitle={formTitle}
          cta={cta}
          containerStyle={styles.hero__contactForm}
        />
      </div>

      <div className={styles.hero__pressItems}>
        {items.map((item) => (
          <div key={item._key} className={styles.hero__pressItem}>
            <div className={styles.hero__pressItemText}>{item.review}</div>

            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={item.sourceLogo} alt="source logo" />
          </div>
        ))}
      </div>
    </ImageBackground>
  );
};

export default HeroSection;
